import Environments, { Brands } from '@delta-defense/client-environments';
import { MemberTypes } from '@delta-defense/client-environments/environments/enums/memberTypes';

Environments.localBrand = Brands.USCCA;

export const Domains = {
  Local: 'localhost',
  Dev: '.dev.usccadev.com',
  Staging: '.usccadev.com',
  CabelasShield: '.cabelas-shield.com',
  Production: '.usconcealedcarry.com'
};

export const DDComUrls = {
  Local: 'http://0.0.0.0:4000',
  Dev: 'https://www.dev.deltadefensedev.com',
  Staging: 'https://www.deltadefensedev.com',
  Production: 'https://www.deltadefense.com'
};
export class EnvironmentService {
  static #instance: EnvironmentService | null = null;

  static Instance() {
    if (!EnvironmentService.#instance) {
      EnvironmentService.#instance = new EnvironmentService();
    }

    return EnvironmentService.#instance;
  }

  static Destroy() {
    EnvironmentService.#instance = null;
  }

  private constructor() { }

  get isLocal() {
    return Environments.isLocal();
  }

  get isDev() {
    return Environments.isDev();
  }

  get isStaging() {
    return Environments.isStaging();
  }

  get isProduction() {
    return Environments.isProduction();
  }

  get isCabelasShield() {
    return Environments.isCabelasShieldBrand();
  }

  get domain() {
    if (this.isLocal) {
      return Domains.Local;
      // NOTE: moved cabelas check higher to avoid issue with uscca domain
    } else if (this.isCabelasShield) {
      return Domains.CabelasShield;
    } else if (this.isDev) {
      return Domains.Dev;
    } else if (this.isStaging) {
      return Domains.Staging;
    } else {
      return Domains.Production;
    }
  }

  get ddComUrl() {
    if (this.isLocal) {
      return DDComUrls.Local;
    } else if (this.isDev) {
      return DDComUrls.Dev;
    } else if (this.isStaging) {
      return DDComUrls.Staging;
    } else {
      return DDComUrls.Production;
    }
  }

  get ddComSSO() {
    return this.ddComUrl + '/authenticate';
  }

  get crossBrandSSO() {
    return (Environments.isCabelasShieldBrand()
      ? Environments.getOrganicDomain('https://www.usccadev.com')
      : Environments.getCabelasShieldDomain('https://staging.www.cabelas-shield.com')) + '/authenticate';
  }

  get crossBrandPortalRedirect() {
    return (Environments.isCabelasShieldBrand()
      ? Environments.getPortalDomain('https://portal.usccadev.com', MemberTypes.UsccaMember)
      : Environments.getPortalDomain('https://staging.login.cabelas-shield.com', MemberTypes.CabelasMember)) + '/redirect';
  }
}
